import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import Button from './header-elements/button';
import Cover from './header-elements/cover';
import Desc from './header-elements/desc';
import ShortLogo from './header-elements/short-logo';
import Title from './header-elements/title';

const Article = styled.article`
  height: ${props => (props.theme.isPortrait ? 'auto' : '100vh')};
  max-height: ${props => (props.theme.isPortrait ? 'none' : '772px')};
  padding-top: ${props => (props.theme.isPortrait ? 74 : 106)}px;
  background: linear-gradient(0deg, #8ea3b5, #11113e);
  border-bottom-right-radius: ${props => (props.theme.isPortrait ? '20vw' : '20vh')};
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.theme.isPortrait ? 'space-around' : 'center')};
  align-items: start;
`;

const Flex = styled.div`
  display: flex;
`;

const HFlex = styled(Flex)`
  flex-direction: row;
  justify-content: center;

  &:after {
    order: 0;
    content: "";
    position: relative;
    height: auto;
    width: 18.6vw;
    max-width: 268px;
  }
`;

const Left = styled(Flex)`
  order: -1;
  flex-direction: column;
  width: 35vw;
  max-width: 504px;
  justify-content: start;
  align-items: start;
`;

const Right = styled(Flex)`
  order: 1;
  width: 26.4vw;
  max-width: 380px;
`;

const VFlex = styled(Flex)`
  flex-direction: column;
`;

const HCenter = styled(VFlex)`
  align-items: center;
`;

export default function Header({ header }) {
  const { isPortrait } = React.useContext(ThemeContext);
  const { title, buttonText, desc } = header;

  return (
    <Article>
      {isPortrait
        ? (
          <VFlex>
            <ShortLogo />
            <Title text={title} />
            <Desc text={desc} />
            <HCenter>
              <Cover />
            </HCenter>
            <Button text={buttonText} />
          </VFlex>
        )
        : (
          <HFlex>
            <Left>
              <ShortLogo />
              <Title text={title} />
              <Desc text={desc} />
              <Button text={buttonText} />
            </Left>
            <Right>
              <Cover />
            </Right>
          </HFlex>
        )}
    </Article>
  );
}

Header.propTypes = {
  header: PropTypes.shape({
    title: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
  }).isRequired,
};
